import React, { useEffect, useState } from "react";
import { getColorsOptions, getSizesOptions } from "../js/toolsOptions";
import Utility from "../js/utility";
import TopMenu from "./TopMenu";
import StickersButton from "./Stickers";
import BotMenu from "./BotMenu";
import ToolMenu from "./ToolMenu";
import ChosenImage from "./ChosenImage";
import BotRight from "./BotRight";
import CameraStream from "./CameraStream";
import Message from "./Message";
import { Common } from "./Canvas";

let initialColors = getColorsOptions("pencil");
let initialSizes = getSizesOptions("pencil");

export default function Menus() {
  const [colors, setColors] = useState(initialColors);
  const [sizes, setSizes] = useState(initialSizes);
  const [rightMenu, setRightMenu] = useState();

  const handleRightMenu = (menuName) => {
    setRightMenu(menuName);
  };

  // hide sub menus when mousedown on canvases;
  useEffect(() => {
    let main_canvas = document.querySelector(".main_canvas");
    let spray_canvas = document.querySelector(".spray_canvas");
    let tape_wrapper = document.querySelector(".tape_wrapper");

    let stickersMenu = document.querySelector(".stickersContainer");
    let toolMenu = document.querySelector(".pickMenuContainer");
    let patternMenu = document.querySelector(".rightMenuContainer");

    main_canvas.addEventListener("pointerdown", removeSubMenus);
    spray_canvas.addEventListener("pointerdown", removeSubMenus);
    tape_wrapper.addEventListener("pointerdown", removeSubMenus);

    function removeSubMenus() {
      stickersMenu.classList.remove("showTabMenu");
      toolMenu.className = "pickMenuContainer";
      patternMenu.classList.remove("showPatternMenu");
    }

    return () => {
      main_canvas.removeEventListener("pointerdown", removeSubMenus);
      spray_canvas.removeEventListener("pointerdown", removeSubMenus);
      tape_wrapper.removeEventListener("pointerdown", removeSubMenus);
    };
  }, []);

  // retrieve menus only once, here, to be accessible in utility;
  useEffect(() => {
    // Utility.top_left = document.querySelector(".top_left_menu");
    Utility.top_right = document.querySelector(".top_right_menu");
    Utility.bot = document.querySelector(".botMenuContainers");
    Utility.left = document.querySelector(".stickersButton");
  }, []);

  return (
    <>
      <TopMenu />
      <StickersButton />
      <BotMenu
        setColors={setColors}
        setSizes={setSizes}
        handleRightMenu={handleRightMenu}
      />
      <ChosenImage />
      {!Common.mobile ? <CameraStream /> : ""}
      <ToolMenu colors={colors} sizes={sizes} />
      <BotRight rightMenu={rightMenu} />
      <Message />
    </>
  );
}
